export default __webpack_public_path__ + "static/images/TIGERSHARES-logo.8eb13006.png";